import { Helmet } from "react-helmet-async";
import { Header } from "@/components/layout/Header.tsx";
import { Hero } from "@/components/sections/Hero.tsx";
import { Newsletter } from "@/components/sections/Newsletter.tsx";
import { Footer } from "@/components/layout/Footer.tsx";

export function Index() {
  return (
    <>
      <Helmet>
        <title>Flying | Merlin Aviation Inc | Moriarty</title>
        <meta
          name="description"
          content="Merlin Aviation inc provides glider rides, flight training, and other aviation services. Call to schedule your soaring adventure."
        />
        <meta property="og:title" content="Flying | Merlin Aviation Inc | Moriarty" />
        <meta
          property="og:description"
          content="Merlin Aviation inc provides glider rides, flight training, and other aviation services. Call to schedule your soaring adventure."
        />
        <meta property="og:url" content="https://www.merlinaviation.net" />
        <meta property="og:site_name" content="Merlin Aviation Inc" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="google-site-verification" content="4Tl8IrSBFyLn8zRub6hfKYkZ_yG1xwsSyBmxy_HJO9o" />
        <meta name="msvalidate.01" content="AD43B6EAA450FA01B5FA589DB915C5B7" />
      </Helmet>

      <div className="relative min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Hero />
          <Newsletter />
        </main>
        <Footer />
      </div>
    </>
  );
}
